import axios from 'axios';

export default (options) => {
  var ax = axios.create({
    baseURL: options.baseUrl,
    headers: {
      Authorization: options.token ? options.token : ''
    }
  });

  const app = options.app;

  const $query = (query) => {
    return ax.get(query);
  };
  const $post = (url, data) => {
    return ax.post(url, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  };
  const $loadPageByUrl = (_url, setTitle = false) => {
    const url = _url.split('?')[0].split('#')[0];
    return new Promise((resolve, reject) => {
      var pageObject = app.config.globalProperties.$store.state.pages[url];
      if (typeof pageObject !== 'object') {
        var contId =
          '#pageData_' +
          url.split('/').filter(Boolean).join('/').replaceAll('/', '_');
        let pageDataContainer = document.querySelector(contId);
        if (pageDataContainer) {
          var parsed = JSON.parse(pageDataContainer.innerHTML);
          if (typeof parsed === 'object' && parsed !== null) {
            app.config.globalProperties.$store.state.pages[url] = parsed;
            resolve(parsed);
            return;
          }
        }
        $query('page_by_url' + url).then((resp) => {
          if (resp.data) {
            app.config.globalProperties.$store.state.pages[url] = resp.data;
            resolve(resp.data);
          } else {
            resolve(0);
          }
        });
      } else {
        resolve(pageObject);
      }
    });
  };
  const $loadGeneral = (locale) => {
    return new Promise(async (resolve) => {
      if (!app.config.globalProperties.$store.state.general[locale]) {
        let generalContainer = document.querySelector('#general_' + locale);
        if (generalContainer) {
          var parsed = JSON.parse(generalContainer.innerHTML);
          if (typeof parsed === 'object' && parsed !== null) {
            app.config.globalProperties.$store.state.general[locale] = parsed;
            resolve();
            return;
          }
        }
        const response = await $query('general/' + locale);
        app.config.globalProperties.$store.state.general[locale] =
          response.data;
      }
      resolve();
    });
  };

  const $loadCookieConsentStrings = (locale) => {
    return new Promise(async (resolve) => {
      if (!app.config.globalProperties.$store.state.cookieConsentStrings[locale]) {
        const response = await $query('cookieconsent/' + locale);
        app.config.globalProperties.$store.state.cookieConsentStrings[locale] =
          response.data;
      }
      resolve(app.config.globalProperties.$store.state.cookieConsentStrings[locale]);
    });
  };

  return {
    $query,
    $post,
    $loadPageByUrl,
    $loadGeneral,
    $loadCookieConsentStrings
  };
};
